import { useMemo } from "react";
import { PatientAvatar } from "./patient-details-drawer/PatientAvatar";
import { PatientMeta } from "./PatientMeta";
import { PaymentCardShortInfo } from "@/features/payment/types";
import { CommandPaletteResult } from "@/components/command-palette/types";
import { useCommandPaletteStore } from "@/components/command-palette/commandPaletteStore";
import { CardStatusBadge } from "..";
import { twMerge } from "tailwind-merge";
import { Patient } from "../types";

interface PatientResultItemProps {
  patient: Patient;
  cardInfo: PaymentCardShortInfo | null;
  onSelect: VoidFunction;
  flatResults: CommandPaletteResult[];
}

export function PatientResultItem({
  patient,
  flatResults,
  cardInfo,
  onSelect,
}: PatientResultItemProps) {
  const flatIndex = useMemo(
    () =>
      flatResults.findIndex((r) => r.patient?.patientId === patient.patientId),
    [flatResults, patient.patientId],
  );

  const isSelected = useCommandPaletteStore(
    (s) => s.selectedIndex === flatIndex,
  );
  const setSelectedIndex = useCommandPaletteStore((s) => s.setSelectedIndex);
  const fullName = `${patient.firstName} ${patient.lastName}`;

  return (
    <button
      data-selected={isSelected}
      onClick={onSelect}
      onMouseEnter={() => setSelectedIndex(flatIndex)}
      className={twMerge(
        "flex w-full cursor-pointer items-center gap-3 border-0 px-5 py-2 text-left transition-colors duration-100",
        isSelected ? "bg-brand-gray" : "bg-transparent",
      )}
    >
      <PatientAvatar fullName={fullName} className="size-8 text-[11px]!" />

      <div className="flex flex-1 flex-col gap-px">
        <span className="overflow-hidden text-[13px] font-semibold text-ellipsis whitespace-nowrap">
          {fullName}
        </span>
        <PatientMeta patient={patient} />
      </div>

      {/* set the same width as in no card bage so they are aligned */}
      <div className="w-[90px]">
        <CardStatusBadge
          type="details"
          cardInfo={cardInfo}
          className="gap-2"
          last4ClassName="text-[13px] text-[#667085] font-semibold"
        />
      </div>
    </button>
  );
}
